module.exports = __webpack_public_path__ + "img/img5.13a43a22.svg";